<ng-container [formGroup]="adult_child_room">
  <mat-form-field floatLabel="auto" [matMenuTriggerFor]="guest_Count">
    <mat-icon matPrefix class="hotelIcon"><img src="../../../assets/svgIcon/user_icon.svg" alt="" class="img-fluid"></mat-icon>
    <div class="guestInput">
      <span><input matInput placeholder="Add Guests" [formControl]="no_guest" autocomplete="off" [ngModel]="adults" readonly>Guest&nbsp;&nbsp;</span>
      <span><input matInput placeholder="Add Guests" [formControl]="no_room" autocomplete="off" readonly>Room</span>
    </div>
    <mat-menu #guest_Count="matMenu">
      <mat-accordion>
        <div *ngFor="let item of dosArray.controls; let i = index">
            <ng-container formArrayName="guest_room_add">
            <ng-container [formGroupName]="i">
              <mat-expansion-panel (opened)="setStep(0)" [expanded]="step === 0" *ngIf="dosArray.length > 0">
                <mat-expansion-panel-header (click)="$event.stopPropagation()">
                  <mat-panel-title>Room&nbsp;{{ i+1 }}</mat-panel-title>
                </mat-expansion-panel-header>
                <section class="guest_section">
                  <div class="add_guest">
                    <label>Adult</label>
                    <div class="inputDesign">
                      <span class="subTr" (click)="$event.stopPropagation()" (click)="counterAdult(i)">-</span>
                      <input matInput (click)="$event.stopPropagation()" formControlName="adult_count_number" [ngModel]="adults" readonly>
                      <span class="plus" (click)="$event.stopPropagation()" (click)="counterAdults(i)">+</span>
                    </div>
                  </div>
                </section>
              </mat-expansion-panel>
            </ng-container>
          </ng-container>
          </div>
          <div class="add_room">
            <button mat-button (click)="submit()">submit</button>
            <button mat-button [disabled]="(rooms === 8)" (click)="add_room()" (click)="counter_room('add_room')"  (click)="$event.stopPropagation()"><mat-icon>add</mat-icon>&nbsp;Add Room</button>
          </div>
        </mat-accordion>
    </mat-menu>
  </mat-form-field>
</ng-container>
